// extracted by mini-css-extract-plugin
var _1 = "Table_center__ecff0";
var _2 = "Table_pdf__0b736";
var _3 = "Table_preview__f5f4f";
var _4 = "Table_selectedArea__06042";
var _5 = "Table_table__24061";
var _6 = "Table_tableContainer__17032";
var _7 = "Table_wrapper__ada52";
export { _1 as "center", _2 as "pdf", _3 as "preview", _4 as "selectedArea", _5 as "table", _6 as "tableContainer", _7 as "wrapper" }
